import { render, staticRenderFns } from "./resource-kejian.vue?vue&type=template&id=1068a739&scoped=true&"
import script from "./resource-kejian.vue?vue&type=script&lang=ts&"
export * from "./resource-kejian.vue?vue&type=script&lang=ts&"
import style0 from "./resource-kejian.vue?vue&type=style&index=0&id=1068a739&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068a739",
  null
  
)

export default component.exports